import type { MachineResource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { repository } from "~/clientInstance";
import { MachineConnectivityPage } from "./MachineConnectivityPage";
type WorkerConnectivityProps = {
    machineId: string;
};
export function WorkerConnectivityPage({ machineId }: WorkerConnectivityProps) {
    return <MachineConnectivityPage repository={repository.Workers} itemDescription={"worker machine"} getConnectionStatus={(machine: MachineResource) => repository.Workers.getConnectionStatus(machine)} machineId={machineId}/>;
}
